import React, { useState } from "react";
import { postApiLoginAsyn } from "../../Services/PostAPI";
import { Button } from "react-bootstrap";
import { Redirect, Link } from "react-router-dom";
import "./index.css";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsSuccess(false);
    setIsError(false);
    setError("");
    try {
      const reqData = { email };
      const res = await postApiLoginAsyn("forgot-password", reqData);
      if (res && res.status === 200) {
        setIsSuccess(true);
      } else {
        setIsError(true);
        setError("Failed to send reset link.");
      }
    } catch (err) {
      setIsError(true);
      setError("Failed to send reset link.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ff-forget-container">
      <div className="ff-forget-box">
        <h3 className="ff-forget-title">Forgot Password</h3>
        <div className="ff-forget-desc">
          We just need your registered Email Id to send you password reset
          instructions.
        </div>
        <form className="ff-forget-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            className="form-control"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
          />
          <Button disabled={isLoading} type="submit" variant="primary">
            {isLoading ? "Sending..." : "Get Instructions"}
          </Button>
        </form>
        {isSuccess && (
          <div className="alert alert-success">
            Reset link sent! Check your email.
          </div>
        )}
        {isError && (
          <div className="alert alert-danger">
            {error || "Failed to send reset link."}
          </div>
        )}
        <div className="ff-forget-links">
          <Link to="/">Login</Link>
        </div>
        {/* <div className="ff-forget-signup">
          <p>
            Don't have an account?{" "}
            <a
              target="_blank"
              href="https://app.easyonbooks.com/register.jsf?jfwid=3043"
            >
              Sign up.
            </a>{" "}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default ForgetPassword;
